// extracted by mini-css-extract-plugin
export default {"StepAuthenticationGate__Headline":"StepAuthenticationGate__Headline_UZhNN","StepAuthenticationGate__Content":"StepAuthenticationGate__Content_Lh7jG"};